import { mutatorAction } from 'satcheljs';
import { MeetingRequestViewState } from 'owa-meeting-message/lib/store/schema/MeetingRequestViewState';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';

export const setResponseType = mutatorAction(
    'setResponseType',
    (meetingRequestViewState: MeetingRequestViewState, responseType: ResponseTypeType) => {
        meetingRequestViewState.responseType = responseType;
    }
);
